const extractElementIdFromPath = (path) => {
  const idMatch = path.match(/\[id\^="([^"]+)"\]/);
  return idMatch?.[1];
};

export const findMatchingElement = (annotation, learnosityItemReference) => {
  const { path, selection, color, offset } = annotation.highlight;

  const elementId = extractElementIdFromPath(path);

  const referenceElement = elementId
    ? document.querySelector(
        `[data-reference="${learnosityItemReference}"] [id^="${elementId}"]`,
      )
    : null;

  const matchingElement = referenceElement
    ? Array.from(
        referenceElement.querySelectorAll(
          `[data-original-offset-start="${offset}"].lrn-annotations-color--${color}`,
        ),
      ).find((el) => el.innerText === selection)
    : null;

  return matchingElement;
};
